import React, {useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import Toaster from "../../../components/Toaster";
import buttonRightArrow from '../../../assets/buttons/button-arrow.svg';
import {confirmAlert} from 'react-confirm-alert';
import Icon from 'react-web-vector-icons';
import * as userActions from "../../../redux/User/actions";
import moment from 'moment';
import LoadingClock from "../../../components/LoadingClock";
import Button from "../../../components/Button";
import Row from "../../../components/Row";
import constants from "../../../utils/constants.js";

import './SavedListsTable.scss';

const SavedListsTable = props => {
	const [loading, setLoading] = useState(true);
	const [waiting, setWaiting] = useState(false);
	const [data, setData] = useState([]);
	const dispatch = useDispatch();
	const { onListLoaded } = props;

	useEffect(() => {
		const load = async () => {
			await dispatch(userActions.getAllUserLists(listsLoaded));
		};
		load();
	}, []);

	const onDelete = row => {
		confirmAlert({
			customUI: ({ onClose }) => {
				return (
					<div className="saved-list-confirm-container">
						<div style={{fontSize: '26px', fontWeight: 'bold'}}>Delete List</div>
						<p>"{row.name}" will be deleted. Continue?</p>
						<br/>
						<Row style={{columnGap: '20px'}}>
							<Button
								type="danger"
								center width={100}
								onClick={() => {
									dispatch(userActions.deleteUserList(row.id, () => {
										setData(data.filter(d => d.id !== row.id));
										Toaster.showSuccess(`Done!`);
									}));
									onClose();
								}}
							>
								Delete
							</Button>
							<Button center width={100} onClick={onClose}>Cancel</Button>
						</Row>
					</div>
				);
			}
		});
	};

	const loadList = async row => {
		setWaiting(true);
		await dispatch(userActions.loadUserList(row, (result) => {
			onListLoaded(result);
			setWaiting(false);
		}));
	};

	const listsLoaded = (data) => {
		setData(data);
		setLoading(false);
	};

	const headers = ['List Name', 'Description', 'Accounts', 'Vendor', 'Updated', '', '', ''];

	const renderRow = (row, i) => {
		return (
			<React.Fragment key={Math.random()}>
				<div className="saved-lists-grid-cell saved-lists-grid-long" title={row.name}>{row.name}</div>
				<div className="saved-lists-grid-cell saved-lists-grid-long" title={row.description}>{row.description}</div>
				<div className="saved-lists-grid-cell">{row.num_of_accounts}</div>
				<div className="saved-lists-grid-cell">{row.vendor.toUpperCase()}</div>
				<div className="saved-lists-grid-cell">{moment(row.updated_at).format(constants.DATETIME_FOTMAT)}</div>
				<div className="saved-lists-grid-cell saved-lists-grid-link" title="Load List">
					<Button rightIcon={buttonRightArrow} onClick={() => loadList(row)}>Go</Button>
				</div>
				<div className="saved-lists-grid-cell saved-lists-grid-link" onClick={() => onDelete(row)} title="Delete"><Icon name="delete" font="AntDesign" color="#6A8991" size={24} /></div>
				<div />
			</React.Fragment>
		)
	};

	if(loading) {
		return <div/>;
	}

	if(data.length < 1) {
		return (
			<div style={{padding: '30px'}}>No saved lists.</div>
		)
	}

	return (
		<div className="saved-lists-grid-container" style={{width: '100%'}}>
			{ waiting && <LoadingClock /> }

			{ headers.map((h, i) => <div className="saved-lists-grid-header" key={i}>{h}</div>)}
			{ data.map((r, i) => renderRow(r, i))}
		</div>
	)
};

export default SavedListsTable;
